module.exports = __webpack_public_path__ + "static/media/butler-with-ipad.f61ac06c.jpg";